import React, { useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import "./MobileHeader.css";
import LogoImage from "../img/a6fbc02e1270717ab963b6d5928edcec5bb01a1174b13c49daba957378db2aa2.png";
import ProfileDropdown from "./ProfileDropdown";
import { useStandalonePwa } from "../hooks/useStandalonePwa";
import { useCompactNav } from "../utils/compactNav";

function MobileHeader({
  onMenuToggle,
  isMenuOpen,
  userProfile,
  profileImage,
  showGlobalSearch = false,
  onGlobalSearchClick,
}) {
  const isMobile = useCompactNav();
  const isStandalonePwa = useStandalonePwa();

  useEffect(() => {
    if (isMobile && isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobile, isMenuOpen]);

  if (!isMobile) {
    return null;
  }

  return (
    <header
      className={`mobile-header-container${isStandalonePwa ? " mobile-header-container--pwa" : ""}`}
    >
      <div className="mobile-header-top">
        <button
          type="button"
          className={`hamburger-menu${isMenuOpen ? " active" : ""}${isStandalonePwa ? " hamburger-menu--pwa" : ""}`}
          onClick={(event) => {
            event.stopPropagation();
            onMenuToggle?.();
          }}
          aria-label="Toggle menu"
          aria-expanded={Boolean(isMenuOpen)}
        >
          <svg width="20" height="20" viewBox="0 0 18 18" fill="none" aria-hidden="true">
            <path
              d={isStandalonePwa ? "M2.5 4.5H15.5M2.5 9H15.5M2.5 13.5H15.5" : "M1 9H12M1 3H17M1 15H6"}
              stroke="currentColor"
              strokeWidth={isStandalonePwa ? "1.75" : "2"}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className={`mobile-logo${isStandalonePwa ? " mobile-logo--pwa" : ""}`}>
          <img
            src={LogoImage}
            alt="Nettles Logo"
            className="mobile-logo-image"
          />
        </div>

        <div className="mobile-header-actions">
          {showGlobalSearch ? (
            <button
              type="button"
              className={`mobile-global-search-btn${isStandalonePwa ? " mobile-global-search-btn--pwa" : ""}`}
              aria-label="Search projects"
              onClick={onGlobalSearchClick}
            >
              <FiSearch aria-hidden="true" />
            </button>
          ) : (
            <div className="mobile-global-search-spacer" aria-hidden="true" />
          )}

          <div className={`mobile-profile${isStandalonePwa ? " mobile-profile--pwa" : ""}`}>
            <ProfileDropdown
              displayName={userProfile?.displayName || ""}
              jobTitle={userProfile?.jobTitle || ""}
              email={userProfile?.mail || userProfile?.userPrincipalName || ""}
              profileImage={profileImage}
              variant="mobile"
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default MobileHeader;
